<template>
    <div class="direct-referral">
        <div>
            <common-page-header
                :heading="$t('modals.make_direct_referal_modal.refer_directly_ancillary')"
                :isCenter="true"
                contentSpacing="medium"
                size="minor"
            ></common-page-header>

            <common-content-spacer height="medium">
                <practice-card :practice="ancillaryPractice"></practice-card>

                <common-content-spacer height="huge">
                    <common-divider>
                        <p class="direct-referral__check_availability_header">
                            {{ $t('modals.make_direct_referal_modal.availability') }}
                        </p>
                    </common-divider>

                    <availability-locations
                        :hoverTitle="$t('pages.profile.professional.availability.check')"
                        :maxNumberOfItems="3"
                        :locations="locations"
                        @go-to-location="goToSchedule($event)"
                    ></availability-locations>
                </common-content-spacer>
            </common-content-spacer>
        </div>
    </div>
</template>

<script>
    import AvailabilityLocations from 'components/page-elements/profile/AvailabilityLocations'
    import PracticeCard from 'components/page-elements/practice/PracticeCard'

    export default {
        components: {
            AvailabilityLocations,
            PracticeCard,
        },

        props: {
            ancillaryPractice: { type: Object, default: null },
        },

        computed: {
            locations() {
                return this.ancillaryPractice.locations
            },
        },

        methods: {
            goToSchedule({ practiceLocationId }) {
                const query = {
                    ...this.$route.query,
                    practiceLocationId: practiceLocationId || 0,
                    practiceId: this.ancillaryPractice.id,
                    isMatchReferral: true,
                }
                this.$router.push({
                    name: `referrals.services.tests`,
                    query: query,
                    params: {
                        existingReferral: false,
                    },
                })
                this.emitEvent({ name: 'location-selected' })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/referrals/_app-direct-referral';
</style>
